<template>
  <svg width="38" height="44" viewBox="0 0 38 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.8101 36.8686L23.6422 36.9137L23.5384 37.0533L18.9999 43.1616L14.4616 37.0533L14.3579 36.9137L14.1899 36.8686C6.30447 34.7513 0.5 27.5529 0.5 19C0.5 8.78273 8.78273 0.5 19 0.5C29.2173 0.5 37.5 8.78273 37.5 19C37.5 27.5529 31.6955 34.7513 23.8101 36.8686Z" fill="#E5D1CA" stroke="#303147"/>
    <path d="M18.6547 23H17.8094V26.5L15 33H16L18.3094 31L19 33H20.5L21.1906 31L23.5 33H24.5L21.6906 26.5V23H20.8453M18.6547 23V16M18.6547 23H20.8453M18.6547 16H17M18.6547 16V12M18.6547 16H20.8453M18.6547 12C18.2931 12 18 11.7069 18 11.3453V9.80616C18 9.44458 18.2931 9.15145 18.6547 9.15145H19.71M18.6547 12H20.8453M19.71 9.15145H20.8453C21.2069 9.15145 21.5 9.44458 21.5 9.80616V11.3453C21.5 11.7069 21.2069 12 20.8453 12M19.71 9.15145V4M20.8453 23V16M20.8453 16H22.5M20.8453 16V12M16.5 20H22.5M18.5 7.5H20.8453" stroke="#303947" stroke-width="1.5"/>
  </svg>
</template>

<script>
export default {
  name: 'PanoramaIconTower'
}
</script>

<style scoped lang="scss">
svg {}
</style>
